import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { LoaderService } from '../../services/loader.service';
import { CommonModule } from '@angular/common';
import { CoreService } from '../../services/core.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  imports: [CommonModule],
  styleUrl: './loader.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoaderComponent {
  constructor(public loader: LoaderService) {}

  visible = computed(() => this.loader.loaderState().visible);
  text = computed(() => this.loader.loaderState().text);
  isDarkTheme = computed(() => this.loader.loaderState().theme === 'dark');
}
